import { Component } from 'react';
import './error-boundary.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      error: null, 
      errorInfo: null,
      countdown: 60, // 5 minutes in seconds
    };
    this.timerInterval = null;
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });

    const lastErrorTime = localStorage.getItem('lastErrorTime');
    const now = Date.now();

    const oneMinute = 60 * 1000;

    if (!lastErrorTime || now - Number(lastErrorTime) > oneMinute) {
      localStorage.setItem('lastErrorTime', now.toString());
      window.location.reload();
      return;
    }

    // Start countdown timer
    this.timerInterval = setInterval(() => {
      this.setState((prev) => {
        if (prev.countdown <= 1) {
          clearInterval(this.timerInterval);
          localStorage.setItem('lastErrorTime', Date.now().toString());
          window.location.reload();
        }
        return { countdown: prev.countdown - 1 };
      });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  render() {
    const { message } = this.props;
    const { error, errorInfo, countdown } = this.state;

    if (errorInfo) {
      return (
        <div className="error-boundary">
          <div className="error-boundary__content">
            <h2 className="error-boundary__content__title">
              Something went wrong
            </h2>

            <div className="error-boundary__content__error">
              {message || (error && error.toString())}
            </div>

            {!message && errorInfo?.componentStack && (
              <details className="error-boundary__content__stack">
                <summary>Details</summary>
                <pre><code>{errorInfo.componentStack}</code></pre>
              </details>
            )}
            <br />
            <div className="error-boundary__content__timer">
              Reloading in 
              {' '}
              <strong>{countdown}</strong>
              {' '}
              seconds...
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
